interface CacheEntry<T> {
  timestamp: number;
  ttl: number;
  data: T;
}

function makeKey<T>(cachePrefix: string, endpoint: string, params?: T) {
  return `${cachePrefix}${endpoint}?${JSON.stringify(params || {})}`;
}

function get<T>(key: string): T | null {
  const raw = sessionStorage.getItem(key);
  if (!raw) return null;

  try {
    const parsed: CacheEntry<T> = JSON.parse(raw);
    if (Date.now() - parsed.timestamp > parsed.ttl) {
      sessionStorage.removeItem(key);
      return null;
    }
    return parsed.data;
  } catch {
    sessionStorage.removeItem(key);
    return null;
  }
}

function set<T>(key: string, data: T, ttl: number) {
  const entry: CacheEntry<T> = {
    timestamp: Date.now(),
    ttl,
    data,
  };
  sessionStorage.setItem(key, JSON.stringify(entry));
}

function cleanExpired(cachePrefix: string): void {
  const now = Date.now();
  for (let i = sessionStorage.length - 1; i >= 0; i--) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(cachePrefix)) {
      try {
        const raw = sessionStorage.getItem(key);
        const parsed: CacheEntry<any> = JSON.parse(raw!);
        if (now - parsed.timestamp > parsed.ttl) {
          sessionStorage.removeItem(key);
        }
      } catch {
        sessionStorage.removeItem(key);
      }
    }
  }
}

function cleanAll(cachePrefix: string): void {
  for (let i = sessionStorage.length - 1; i >= 0; i--) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(cachePrefix)) {
      sessionStorage.removeItem(key);
    }
  }
}

export const Cache = {
  makeKey,
  set,
  get,
  cleanAll,
  cleanExpired,
};
